module.exports = __webpack_public_path__ + "media/images/flags/GB-cb6930db06b0bb2f23e6487943ee538d.svg";